import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CalendarDays, MapPin, Building2, ArrowRight } from "lucide-react";
import { fmtDate } from "../lib/api";
import { localeOf } from "../i18n";

export const PublicEventCard = ({ event }) => {
  const { t, i18n } = useTranslation();
  const locale = localeOf(i18n.language);
  const image = event.social_image_url || "/social/vytalidays-event-default.jpg";

  return (
    <article className="group overflow-hidden rounded-2xl border border-border bg-card transition-colors hover:border-primary"
      data-testid={`public-event-card-${event.slug}`}>
      <Link to={`/events/${event.slug}`} className="block">
        <img src={image} alt={event.title} width="1200" height="630" loading="lazy"
          className="aspect-[1200/630] w-full object-cover" />
        <div className="p-5">
          {event.campaign_name && (
            <p className="text-xs font-bold uppercase tracking-widest text-accent">{event.campaign_name}</p>
          )}
          <h3 className="mt-1 font-display text-xl font-bold leading-snug">{event.title}</h3>
          <div className="mt-3 space-y-1.5 text-sm text-muted-foreground">
            <p className="flex items-center gap-2"><CalendarDays className="h-4 w-4 shrink-0" />{fmtDate(event.starts_at, locale)}</p>
            {event.location && (
              <p className="flex items-center gap-2"><MapPin className="h-4 w-4 shrink-0" />{event.location}</p>
            )}
            {event.partner?.name && (
              <p className="flex items-center gap-2"><Building2 className="h-4 w-4 shrink-0" />{event.partner.name}</p>
            )}
          </div>
          {event.description && (
            <p className="mt-3 line-clamp-2 text-sm text-muted-foreground">{event.description}</p>
          )}
          <span className="mt-4 inline-flex items-center gap-1 text-sm font-bold text-primary">
            {t("pub.viewEvent")}
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </span>
        </div>
      </Link>
    </article>
  );
};
